module.exports = "/dist/montserrat-latin-700.svg?21c945dee39e064e77a151c1052d1215";


//////////////////
// WEBPACK FOOTER
// ./~/typeface-montserrat/files/montserrat-latin-700.svg
// module id = 78
// module chunks = 0